import React, { FC, MouseEventHandler, PropsWithChildren } from 'react';
import Link from 'next/link';
import { useGetUserStatus } from '../hooks';
import {
  IUserStatusOnClickWrapperProps,
  UserStatusOnClickWrapper,
} from './UserStatusOnClickWrapper';

interface IUserStatusMaybeButtonOrLinkProps extends PropsWithChildren {
  href?: string;
  onClick?: MouseEventHandler;
  forbiddenStatuses?: IUserStatusOnClickWrapperProps['forbiddenStatuses'];
}

export const UserStatusMaybeButtonOrLink: FC<
  IUserStatusMaybeButtonOrLinkProps
> = ({ children, forbiddenStatuses, onClick, href }) => {
  const { status } = useGetUserStatus();

  if (Array.isArray(forbiddenStatuses)) {
    if (forbiddenStatuses.includes(status)) {
      return (
        <UserStatusOnClickWrapper forbiddenStatuses={forbiddenStatuses}>
          <div onClick={() => {}}>{children}</div>
        </UserStatusOnClickWrapper>
      );
    }
  }

  if (href) {
    return <Link href={href}>{children}</Link>;
  }

  if (typeof onClick === 'function') {
    return <div onClick={onClick}>{children}</div>;
  }

  return <div>{children}</div>;
};
